import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/var/www/vhost/sync-frontend/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/@layouts/BlankLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/var/www/vhost/sync-frontend/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhost/sync-frontend/src/components/theme/index.tsx");
